import React, { useContext } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

function TermsOfUse({ onBack }) {

    return (
        <div className="min-h-screen flex flex-col bg-[#f3f4f6]">
            <Helmet>
                <title>Terms of Use | Jackpot Concierge</title>
                <meta
                    name="description"
                    content="Jackpot Concierge Terms of Use and End-User License Agreement."
                />
            </Helmet>

            <Header />

            <div className="flex-grow">
                <div className="max-w-4xl mx-auto px-4 py-6">


                    <div className="mt-6 bg-white rounded-lg shadow-md p-6">
                        <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 text-center">
                            Jackpot Concierge Terms of Use and End-User License Agreement
                        </h1>

                        <p className="mt-4 text-gray-800 leading-7">
                            Please carefully read the Terms of Use and End-User License Agreement as it contains important
                            information regarding your use of Jackpot Concierge. By agreeing to these terms, you acknowledge
                            that you have read, understood, and agreed to be bound by this Agreement. If you do not agree to
                            these terms, please exit the site/application.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">1. Acceptance of Terms</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            This Terms of Use and End-User License Agreement ("Agreement") is a legal agreement between you
                            (either an individual or a single entity) and Jackpot Concierge LLC ("Jackpot Concierge", “we,”
                            “our” or “us” ), for the Jackpot Concierge website and mobile application ("Service"). By creating
                            an account, using the Service, or clicking to accept or agree to this Agreement when this option
                            is made available to you, you agree to be bound by the terms of this Agreement.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">2. Use of Service</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            The Service is intended for adult users (21 years and older) and is designed to provide
                            personalized concierge services.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">3. User Responsibilities</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Users are responsible for maintaining the confidentiality of their account information and for
                            all activities that occur under their account. Users agree to use the Service for lawful purposes
                            only and in a manner consistent with any and all applicable laws and regulations.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">4. Age Restriction</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Users of the Service must be 21 years or older. By agreeing to this Terms of Use and EULA, you
                            represent and warrant that you are of legal age to form a binding contract with Jackpot Concierge.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">5. Data Handling and Privacy</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Jackpot Concierge is committed to protecting the privacy and security of its users' data.
                            Personal information collected through the Service is subject to our Privacy Policy, which is hereby
                            incorporated into this Agreement.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">6. Intellectual Property Rights</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            All rights, title, and interest in and to the Service (excluding content provided by users) are and
                            will remain the exclusive property of Jackpot Concierge and its licensors.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">7. Limitation of Liability</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Jackpot Concierge shall not be liable for any indirect, incidental, special, consequential, or
                            punitive damages, including without limitation, loss of profits, data, use, goodwill, or other
                            intangible losses, resulting from your access to or use of or inability to access or use the Service.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">8. Termination</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Jackpot Concierge may terminate or suspend access to our Service immediately, without prior notice or
                            liability, for any reason whatsoever, including, without limitation, if you breach the Terms.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">9. Governing Law</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            This Agreement shall be governed and construed in accordance with the laws of your state and/or local
                            jurisdiction, without regard to its conflict of law provisions.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">10. Changes to Agreement</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            We reserve the right, at our sole discretion, to modify or replace this Agreement at any time. If a
                            revision is material, we will provide at least 30 days' notice prior to any new terms taking effect.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">11. Indemnification</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            You agree to indemnify, defend, and hold harmless Jackpot Concierge LLC, its affiliates, officers,
                            directors, employees, agents, licensors, and service providers from and against all claims, liabilities,
                            losses, expenses, damages, and costs, including reasonable attorneys' fees, resulting from any violation
                            of this Agreement by you or any harm you may cause to anyone in connection therewith, including information
                            you submit, post, or transmit through the Service, your use of the Service, your violation of any rights
                            of another, or your breach of the above representations, warranties, and covenants. Jackpot Concierge
                            reserves the right, at its own expense, to assume the exclusive defense and control of any matter otherwise
                            subject to indemnification by you, in which event you will cooperate with Jackpot Concierge in asserting
                            any available defenses.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">12. Modifications to the Service</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            We reserve the right at any time to modify or discontinue, temporarily or permanently, the Service (or any
                            part thereof) with or without notice. You agree that Jackpot Concierge shall not be liable to you or to any
                            third party for any modification, suspension, or discontinuance of the Service.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">13. Dispute Resolution</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Any disputes arising out of or related to these Terms or the Service will be resolved by binding arbitration,
                            rather than in court, except that you may assert claims in small claims court if your claims qualify.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">14. Severability</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            If any provision of this Agreement is held to be invalid or unenforceable, such provision shall be struck and
                            the remaining provisions shall be enforced to the fullest extent under law.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">15. Entire Agreement</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            This Agreement constitutes the entire agreement between you and Jackpot Concierge and governs your use of the
                            Service, superseding any prior agreements between you and Jackpot Concierge with respect to the Service.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">16. Compliance with Applicable Laws</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            You agree to use the Service in compliance with all applicable local, state, national, and international laws,
                            rules, and regulations. You shall not use the Service for any unlawful purposes, including but not limited to
                            the violation of any intellectual property rights or privacy laws.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">17. No Waiver</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            The failure of Jackpot Concierge to enforce any right or provision of this Agreement will not be deemed a waiver
                            of such right or provision. Any waiver of any provision of this Agreement will be effective only if in writing and
                            signed by Jackpot Concierge.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">18. Updates and Changes to the Service</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Jackpot Concierge continuously seeks to improve the Service and may update the Service from time to time. You understand
                            and agree that the Service may change without prior notice to you and that Jackpot Concierge may stop (permanently or
                            temporarily) providing the Service (or features within the Service) to you or to users generally.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">19. Feedback and Suggestions</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            If you provide Jackpot Concierge with any feedback or suggestions regarding the Service ("Feedback"), you hereby assign to
                            Jackpot Concierge all rights in the Feedback and agree that Jackpot Concierge shall have the right to use such Feedback and
                            related information in any manner it deems appropriate. Jackpot Concierge will treat any Feedback you provide to Jackpot
                            Concierge as non-confidential and non-proprietary.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">20. Early Development and Bug Disclaimer</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            The Jackpot Concierge platform is currently in early development and may contain bugs, errors, or other issues. While we strive
                            to provide a reliable and smooth user experience, you acknowledge and agree that the Service may not be free from defects or
                            interruptions. Jackpot Concierge shall not be liable for any inconvenience, loss of data, or any other issues arising from the use
                            of the Service in its current development stage. By using the Service, you accept the platform's early development status and the
                            associated risks.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">21. Data Privacy</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            We respect your privacy and offer you control over your personal information. The following rights are specifically granted to
                            residents of California, in compliance with the California Consumer Privacy Act (CCPA) and the California Privacy Rights Act (CPRA):
                        </p>

                        <ul className="mt-3 space-y-3 text-gray-800 list-disc list-inside">
                            <li>
                                <span className="font-extrabold">Right to Know:</span>{" "}
                                California residents have the right to request disclosure of the specific pieces of personal information we have collected about them.
                            </li>
                            <li>
                                <span className="font-extrabold">Right to Delete:</span>{" "}
                                California residents can request the deletion of their personal information that we have collected, subject to certain exceptions.
                            </li>
                            <li>
                                <span className="font-extrabold">Right to Opt-Out:</span>{" "}
                                California residents have the right to opt-out of the sale of their personal information. This right can be exercised by contacting our
                                support team at support@jackpotconcierge.com and requesting to opt-out.
                            </li>
                            <li>
                                <span className="font-extrabold">Right to Non-Discrimination:</span>{" "}
                                California residents will not be discriminated against for exercising any of their CCPA rights.
                            </li>
                        </ul>

                        <p className="mt-3 text-gray-800 leading-7">
                            California residents wishing to exercise these rights can submit a verifiable consumer request to us by emailing support@jackpotconcierge.com.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">22. Refund Policy</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            Jackpot Concierge may issue refunds at its sole discretion.
                            <br />
                            <br />
                            By using Jackpot Concierge, you agree that all payments made to Jackpot Concierge are final.
                            <br />
                            Failure by Jackpot Concierge to successfully complete a booking based on your preferences does not entitle you to a refund.
                            <br />
                            You also waive your right to initiate any chargebacks or disputes with your credit card provider or payment processor against Jackpot Concierge.
                            <br />
                            <br />
                            This policy is in place to ensure the sustainability of our services and to prevent abuse of refund systems.
                            <br />
                            We appreciate your understanding and cooperation.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">23. Booking, Venue Partners, and Experience Policy</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            We will do our best to secure your booking based on your preferences and our connections. However, we can not guarantee bookings in all
                            circumstances and we can not guarantee the venue will have the availability. If venues are fully booked we will do our best to provide a
                            comparable alternative. Failure to successfully complete a booking based on your preferences does not entitle you to a refund as noted in
                            the Refund Policy section of this agreement. Some venues require credit card information to complete a reservation. We may not be able to
                            complete these bookings as we do not have access to your full payment information. We will do our best to connect you with the venue to
                            complete the booking. Although we vet our partners and work with the best companies in the city, we can not guarantee you will have a great
                            experience. Jackpot Concierge is not responsible for poor experiences from third parties or partners. If you do not have a great experience
                            please let us know.
                        </p>

                        <h2 className="mt-6 text-lg font-extrabold text-gray-900">24. Contact Information</h2>
                        <p className="mt-2 text-gray-800 leading-7">
                            If you have any questions about this Agreement, please contact us at support@jackpotconcierge.com
                        </p>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default TermsOfUse;
